var React = require('react');

function IconEnter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M793.36 238.01H238.03V79.34L.03 277.67l238 198.34V317.34h634.66V0h-79.33z"}));
}

IconEnter.displayName = "IconEnter";

IconEnter.defaultProps = {"viewBox":"0 0 872.69 476.01"};

module.exports = IconEnter;

IconEnter.default = IconEnter;
